import Vue from "vue";

Vue.mixin({
    methods: {
        // Sort reference, experience, ... sections
        handleSortDependentSections(listData, builder, listFields) {
            if (!listFields) {
                listFields = [];
                if (builder && builder.list_fields) {
                    listFields = builder.list_fields;
                }
            }
            const additionalInfo = builder ? builder.additionalInformation || builder.additional_information : null;
            // Sort model is specified
            if (
                additionalInfo &&
                additionalInfo.sort_model
            ) {
                const sortModel = additionalInfo.sort_model;
                const isDescending = additionalInfo.is_descending;
                const nullAtTop = additionalInfo.null_at_top;
                listData.sort((item1, item2) => {
                    const val1 = item1[sortModel];
                    const val2 = item2[sortModel];
                    // equal items sort equally
                    if (val1 === val2) {
                        // If section is sorted by end_date, and end_date is equal, sort by start date
                        if (sortModel === "end_date" && nullAtTop) {
                            return item1.start_date > item2.start_date ? -1 : 1;
                        }
                        return 0;
                    }
                    // nulls sort after anything else
                    else if (val1 == null) {
                        return nullAtTop ? -1 : 1;
                    } else if (val2 == null) {
                        return nullAtTop ? 1 : -1;
                    }

                    // Convert string to lower case
                    let normalizedVal1 = val1;
                    if (typeof normalizedVal1 === "string") {
                        normalizedVal1 = normalizedVal1.toLowerCase();
                    }
                    let normalizedVal2 = val2;
                    if (typeof normalizedVal2 === "string") {
                        normalizedVal2 = normalizedVal2.toLowerCase();
                    }

                    // otherwise, if we're ascending, lowest sorts first
                    if (isDescending) {
                        return normalizedVal1 < normalizedVal2 ? 1 : -1;
                    }
                    // if descending, highest sorts first
                    else {
                        return normalizedVal1 < normalizedVal2 ? -1 : 1;
                    }
                });
                return;
            }

            // Sort model is not specified => Default sort
            // Check if start_date is defined
            if (
                listFields &&
                listFields.some((field) => field.model === "start_date")
            ) {
                const hasEndDateField = listFields.some(
                    (field) => field.model === "end_date"
                );

                listData.sort((a, b) => {
                    // Put item without end date to top
                    if (hasEndDateField) {
                        if (!a.end_date && b.end_date) {
                            return -1;
                        }
                        if (a.end_date && !b.end_date) {
                            return 1;
                        }
                    }
                    return a.start_date > b.start_date ? -1 : 1;
                });
            } else {
                listData.sort((a, b) => (a.id > b.id ? 1 : -1));
            }
        },
    }
});


// WEBPACK FOOTER //
// ./src/mixins/sort-handling.js